import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EuiBreadcrumbComponent } from './breadcrumb.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiBreadcrumbComponent,
    ],
    exports: [
        EuiBreadcrumbComponent,
    ],
})
export class EuiBreadcrumbModule { }
